import Component from './lib/component';
import Inputs from './components/inputs';
import Stats from './components/stats';
import api100D from './services/100d';
import apiP100D from './services/p100d';
// Import constants
import {
  STAT_UNIT,
  DEFAULT_SPEED,
  DEFAULT_TEMP,
  DEFAULT_FAN_STATUS,
  DEFAULT_WHEEL_SIZE,
  DEFAULT_100D_DISTANCE,
  DEFAULT_P100D_DISTANCE,
} from './constants';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };

    // Init default values
    this.distanceData = { '100d': [], p100d: [] };
    this.distances = { '100d': DEFAULT_100D_DISTANCE, p100d: DEFAULT_P100D_DISTANCE };
    this.car = {
      speed: DEFAULT_SPEED,
      temp: DEFAULT_TEMP,
      fan: DEFAULT_FAN_STATUS,
      wheelSize: DEFAULT_WHEEL_SIZE,
    };

    // Call update data method to fetch distance data and update distances object values
    this.updateData();

    // Create a new instance of inputs component
    this.inputsComponent = new Inputs({
      elem: '#inputs',
      parent: this,
      watchers: { speed: 'speed', temp: 'temp', fan: 'fan', wheelSize: 'wheelSize' },
      data: this.car,
    });

    // Create a new instance of stats component
    this.statsComponent = new Stats({
      elem: '#stats',
      parent: this,
      data: { distances: this.distances, unit: STAT_UNIT },
    });
  }

  // Update the car object when each of its attributes that specified in the watchers in each child components were changed
  emit(props) {
    Object.keys(props).forEach((key) => {
      if (props[key] !== null && props[key] !== undefined) {
        this.car[key] = props[key];
        // Get new distances based on new props values and update stats component distances prop
        this.updateData();
      }
    });
  }

  // Update distance data for each model
  updateData() {
    Object.keys(this.distanceData).forEach(async (key) => {
      // Check if distance data for each model is empty then fetch data
      if (this.distanceData[key].length === 0) {
        await this.fetchData(key);
      }

      // Get distance value for each model
      const data = this.getDistance(this.distanceData[key]);

      // If distance is not null and zero then update each model distance prop
      if (data) {
        this.updateDistance({ [key]: data });
      }
    });
  }

  // Fetch data from the files for each car model and set distances data prop based on that
  async fetchData(model) {
    let data = [];

    // Check model and get data from the file
    if (model === '100d') {
      data = await api100D.fetch();
    } else if (model === 'p100d') {
      data = await apiP100D.fetch();
    }

    // If response is not empty set the model data value
    if (data.length > 0) {
      this.distanceData[model] = data;
    }
  }

  getDistance(data) {
    // Get speed, temp, fan and wheel size
    const { speed, temp, fan, wheelSize } = this.car;

    const fanStatus = fan ? 'on' : 'off';

    // Filter the data to get exact distance based on the parameters
    const item = data.filter((d) => d.temp === parseFloat(temp) && d.ac === fanStatus && d.wheelsize === parseFloat(wheelSize));
    if (item.length > 0 && item[0].hwy) {
      const distance = item[0].hwy.filter((i) => i.kmh === parseFloat(speed));
      if (distance.length > 0 && distance[0].kilometers) {
        return distance[0].kilometers;
      }
    }
    return null;
  }

  // Update distance of each model
  updateDistance(data) {
    Object.keys(data).forEach((key) => {
      this.distances[key] = data[key];
    });

    // Set stats component distances prop with new data
    this.statsComponent.setState({ distances: this.distances });
  }

  // Load child components and mount them to the view
  load() {
    // Mount inputs component to inputs element
    this.inputsComponent.mount();
    // Mount stats component to stats element
    this.statsComponent.mount();
  }
}

export default App;
